import { render, staticRenderFns } from "./RecordFooter.vue?vue&type=template&id=08878996&scoped=true&lang=pug&"
import script from "./RecordFooter.vue?vue&type=script&lang=ts&"
export * from "./RecordFooter.vue?vue&type=script&lang=ts&"
import style0 from "./RecordFooter.vue?vue&type=style&index=0&id=08878996&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08878996",
  null
  
)

export default component.exports